import dayjs from 'dayjs';

export function isInvalidDate(date: string) {
  return date
    ? dayjs(date).isSameOrBefore(dayjs().subtract(1, 'year')) ||
        dayjs(date).isAfter(dayjs(), 'minute')
    : false;
}
